import { render } from "./legoSegmentButton.vue?vue&type=template&id=6c90723c"
import script from "./legoSegmentButton.vue?vue&type=script&lang=js"
export * from "./legoSegmentButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/element/legoSegmentButton/legoSegmentButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6c90723c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6c90723c', __exports__)) {
    api.reload('6c90723c', __exports__)
  }
  
  module.hot.accept("./legoSegmentButton.vue?vue&type=template&id=6c90723c", () => {
    api.rerender('6c90723c', render)
  })

}


export default __exports__